import { render, staticRenderFns } from "./CrewList.vue?vue&type=template&id=094cc00b&scoped=true&"
import script from "./CrewList.vue?vue&type=script&lang=js&"
export * from "./CrewList.vue?vue&type=script&lang=js&"
import style0 from "./CrewList.vue?vue&type=style&index=0&id=094cc00b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cc00b",
  null
  
)

export default component.exports